import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _templateObject, _templateObject2, _templateObject3;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isoStringToTime } from "../util/time.js";
import { urlPath } from "../util/url.js";
export var newApi = function newApi(_ref) {
  var amsResponse = _ref.amsResponse,
    config = _ref.config;
  var stationImageUrl = function stationImageUrl(station) {
    return "".concat(config.amsBaseUrl, "/v1.1/image/Station_").concat(station.id);
  };
  var stationMapUrl = function stationMapUrl(station) {
    return "".concat(config.amsBaseUrl, "/v1.1/image/Station_").concat(station.id, "_Karte");
  };
  var normalizeStation = function normalizeStation() {
    var station = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread(_objectSpread({}, station), {}, {
      openingInfos: station.openingInfos || [],
      imageUrl: stationImageUrl(station),
      mapUrl: stationMapUrl(station)
    });
  };
  return {
    getStations: function () {
      var _getStations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var contractTypes, data, stations;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              contractTypes = _ref2.contractTypes;
              _context.next = 3;
              return amsResponse.getData({
                method: "GET",
                path: "v1.1/stations",
                query: {
                  contractTypes: contractTypes.join(",")
                }
              });
            case 3:
              data = _context.sent;
              stations = data || [];
              return _context.abrupt("return", stations.map(normalizeStation));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getStations(_x) {
        return _getStations.apply(this, arguments);
      }
      return getStations;
    }(),
    getStation: function () {
      var _getStation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
        var stationId, station;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              stationId = _ref3.stationId;
              _context2.next = 3;
              return amsResponse.getData({
                method: "GET",
                path: urlPath(_templateObject || (_templateObject = _taggedTemplateLiteral(["v1.1/station/", ""])), stationId)
              });
            case 3:
              station = _context2.sent;
              return _context2.abrupt("return", normalizeStation(station));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getStation(_x2) {
        return _getStation.apply(this, arguments);
      }
      return getStation;
    }(),
    getStationOpeningTimes: function () {
      var _getStationOpeningTimes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
        var stationId, data, openingTimes;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              stationId = _ref4.stationId;
              _context3.next = 3;
              return amsResponse.getData({
                method: "GET",
                path: urlPath(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["v1.1/station/", "/openingTimes"])), stationId)
              });
            case 3:
              data = _context3.sent;
              openingTimes = data || [];
              return _context3.abrupt("return", openingTimes.map(function (openingTime) {
                return _objectSpread(_objectSpread({}, openingTime), {}, {
                  fromDate: openingTime.openDate,
                  tillDate: openingTime.openDateTill,
                  fromTime: isoStringToTime(openingTime.openfromTime),
                  tillTime: isoStringToTime(openingTime.openTillTime)
                });
              }));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function getStationOpeningTimes(_x3) {
        return _getStationOpeningTimes.apply(this, arguments);
      }
      return getStationOpeningTimes;
    }(),
    getStationBookingRules: function () {
      var _getStationBookingRules = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5) {
        var stationId, _ref5$contractType, contractType, objectPositionId, exactMatchContractType, data, bookingRules;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              stationId = _ref5.stationId, _ref5$contractType = _ref5.contractType, contractType = _ref5$contractType === void 0 ? "0" : _ref5$contractType;
              objectPositionId = 0; // We want to fetch bookingRules for all objectPositions
              exactMatchContractType = 1; // We want to fetch bookingRules only for the given contractType
              _context4.next = 5;
              return amsResponse.getData({
                method: "GET",
                path: urlPath(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["v1.1/dispSurBookingRules/", "/", "/", "/", ""])), contractType, stationId, objectPositionId, exactMatchContractType)
              });
            case 5:
              data = _context4.sent;
              bookingRules = data || [];
              return _context4.abrupt("return", bookingRules.map(function (bookingRule) {
                return _objectSpread(_objectSpread({}, bookingRule), {}, {
                  valueInMinutes: Number(bookingRule.value)
                });
              }));
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function getStationBookingRules(_x4) {
        return _getStationBookingRules.apply(this, arguments);
      }
      return getStationBookingRules;
    }()
  };
};